import { render, staticRenderFns } from "./r-tabs.vue?vue&type=template&id=ea069fb0"
import script from "./r-tabs.vue?vue&type=script&setup=true&lang=js"
export * from "./r-tabs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./r-tabs.vue?vue&type=style&index=0&id=ea069fb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports